import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlQueryService} from '../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class AttributesApiService {
  constructor(private http: HttpClient) {
  }

  readonly attributesUrl: string = 'identity/dicAttribute';

  public getAttributes(): Promise<any> {
    return this.http.get(this.attributesUrl).toPromise();
  }

  getAttribute(id): Promise<any> {
    return this.http.get(this.attributesUrl + '/' + id).toPromise();
  }

  addAttribute(attr): Promise<any> {
    return this.http.post(this.attributesUrl, attr).toPromise();
  }

  editAttribute(attr): Promise<any> {
    const url = this.attributesUrl + '/' + attr.id;
    return this.http.put(url, attr).toPromise();
  }

  deleteAttribute(attr): Promise<any> {
    const url = this.attributesUrl + '/' + attr.id;
    return this.http.delete(url).toPromise();
  }

  deleteAttributes(ids): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.attributesUrl, {filter: {id: {value: ids, operator: '='}}});
    return this.http.delete(url).toPromise();
  }

  getUserDisplayAttributes(): Promise<any> {
    return this.getAttributes()
      .then((attributes) => {
        const columns = [{
          name: 'name',
          display: 'Name',
          sort: true,
          selected: true,
          width: 200
        },
          {
            name: 'origin',
            display: 'Origin',
            selected: true,
            width: 200
          }
        ];

        attributes.forEach((attribute) => {
          if (attribute && attribute.name && attribute.id && attribute.primary) {
            const fieldName = 'dicAttr_' + attribute.id;

            columns.push({name: fieldName, display: attribute.name, selected: true, width: 200});
          }
        });

        return columns;
      })
      .catch(() => {});
  }

  prepareDataForAttributeAddToServer(): Promise<any> {
    const data = {
      newAttribute: {
        name: '',
        description: '',
        defaultRemoteName: '',
        primary: true,
        isCombined: false,
        dialable: false
      },
      attributes: []
    };

    return this.getAttributes()
      .then((attributes) => {
        data.attributes = attributes;
        return data;
      });
  }

  prepareDataForAttributeEditInServer(id): Promise<any> {
    return Promise.all([this.getAttribute(id), this.getAttributes()]);
  }
}
